export const BANK_SUBMISSION_TYPE = {
  DIRECT_TO_BANK: 'direct-to-bank',
  SUBMIT_THROUGH_HUSPY: 'submit-through-huspy',
} as const;

export type BankSubmissionType = (typeof BANK_SUBMISSION_TYPE)[keyof typeof BANK_SUBMISSION_TYPE];

export const EMAIL_CHANNEL_PROVIDER = {
  SELF: 'self',
  THIRD_PARTY: 'third-party',
} as const;

export type EmailChannelProviderType =
  (typeof EMAIL_CHANNEL_PROVIDER)[keyof typeof EMAIL_CHANNEL_PROVIDER];

export const MAIL_ACTION_TYPES = {
  SELECT_EMAIL_CHANNEL: 'select-email-channel',
  COMPOSE_EMAIL: 'compose-email',
  SUCCESS: 'success',
} as const;

export type MailActionTypes =
  (typeof MAIL_ACTION_TYPES)[keyof typeof MAIL_ACTION_TYPES];

export type ComposeEmailFormValues = {
  sendTo: string[];
  subject: string;
  cc: string[];
  body: string;
};
